module.exports = __webpack_public_path__ + "static/media/pic1.49c443f2.png";